<template>
  <div class="Copy w-bg">
    <div class="w">
      <div class="copy-klm">
        <h2><i class="red">KLM</i><strong>/</strong><i v-if="position == 2">SZ</i><i v-if="position == 1">GZ</i></h2>
      </div>
      <div class="copy-right">
        <ul>
          <li><router-link class="first-level " to="/yscindex">商店首页</router-link></li>
          <li><router-link class="first-level"  to="/salecar">在售车源</router-link></li>
          <li><router-link class="first-level " to="/assessment">在线评价</router-link></li>
          <li><router-link class="first-level " to="/sellingcar">我要卖车</router-link></li>
          <li><router-link class="first-level " to="/substitutioncar">我要换车</router-link></li>
          <li><router-link class="first-level " to="/aboutdesign">联系我们</router-link></li>
        </ul>
        <p>
          <!-- <a style="cursor: pointer;" onclick="window.open('http://beian.miit.gov.cn/')">广州市锦龙汽车发展有限公司</a> -->
          <a style="cursor: pointer;" onclick="window.open('http://beian.miit.gov.cn/')">粤ICP备05097152号</a>
          ©2019 广州市锦龙汽车发展有限公司 版权所有</p>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'Copy',
  data () {
    return {
      position: Cookies.get('position') || 2
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .Copy
    margin-top 10px
    background #000
    color #fff
    .copy-klm
      float left
      padding 30px 20px
      font-style normal
      h2
        font-size 30px
        font-weight 600
        font-family "BB"
        font-style normal
        i
          font-weight 600
          font-style italic
          &.red
            color red
        strong
          font-style normal
          padding 0 4px 0 5px
    .copy-right
      font-size 14px
      float right
      color #8b939e
      padding 22px 20px
      ul,p
        line-height 24px
        text-align right 
        li
          display inline-block
          padding-left 20px 
          a
            color #8b939e
            &:hover
              color #fff
      p 
        float right
        font-family sans-serif  

  // 底下
  @media screen and (min-width: 0) and (max-width: 720px) 
    .Copy 
      .copy-klm
        padding 30px 0 30px 10px
    .copy-right
      padding 22px 10px 22px 0 !important
  @media screen and (min-width: 0) and (max-width: 650px) 
    .Copy 
      .copy-klm
        padding 22px 0 22px 10px !important
      .copy-right
        padding 22px 10px 22px 0 !important
        ul
          display none !important
</style>



// WEBPACK FOOTER //
// src/components/Copy.vue